/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { getHygraphCosmosPageData } from "@cosmos/hygraph-data";
import { Locale, CosmosPagePluginDetailMetadataQuery } from "@cosmos/hygraph-schema";
import { getSlugParam, getHygraphLocale } from "@cosmos/next-common";
import { isError } from "@epic-mw/error-types";
import { Metadata } from "next";

import { CosmosPageMetadata } from "../common/page.types";

const getPageMetadata = async (
	locale: string = Locale.En,
	slug: string,
	previewParam?: string | string[],
	endpoint?: string,
): Promise<CosmosPagePluginDetailMetadataQuery> => {
	const preview = previewParam && typeof previewParam === "string" ? previewParam : undefined;

	if (!slug) {
		throw new Error("Missing slug");
	}
	const resp = await getHygraphCosmosPageData(
		"CosmosPagePluginDetailMetadata",
		{
			locale: [locale, Locale.En] as Locale[],
			slug,
		},
		preview,
		endpoint,
	);

	return resp;
};

export async function cosmosPagePluginDetailMetadata({
	slug: rootSlug = "",
	params,
	searchParams,
	hygraphLocales,
	getAppMetadata,
	hygraphEndpoint,
}: CosmosPageMetadata): Promise<Metadata> {
	const slugParam = getSlugParam(params);
	const slug = `${rootSlug}${slugParam}`;
	const locale = params.lang;
	let pageData: CosmosPagePluginDetailMetadataQuery = {};
	try {
		pageData = await getPageMetadata(
			getHygraphLocale(hygraphLocales, locale),
			slug,
			searchParams.preview,
			hygraphEndpoint,
		);
	} catch (e) {
		console.error("Failed to get cosmosPagePluginDetailMetadata()", { error: isError(e) && e.message });
	}
	const metaTags = pageData.cosmosPagePluginDetail?.metaTags || {};

	return getAppMetadata(metaTags, slug, locale);
}
